import { useEffect, useState } from 'react';
import { Form } from 'antd';
import VoucherService from 'services/voucher';
import { useApp } from 'contexts/app';

const service = new VoucherService();

const toBoolean = (value, fallback = false) => {
  if (value === undefined || value === null) return fallback;
  if (value === true || value === 1 || value === '1' || value === 'true') return true;
  if (value === false || value === 0 || value === '0' || value === 'false') return false;
  return Boolean(value);
};

const normalizeVoucher = (item = {}) => ({
  ...defaultVoucher,
  ...item,
  is_active: toBoolean(item?.is_active, true),
  is_public: toBoolean(item?.is_public, true),
  limit: {
    ...defaultVoucher.limit,
    ...(item?.limit || {}),
    time: {
      ...defaultVoucher.limit.time,
      ...(item?.limit?.time || {}),
    },
  },
});

const defaultVoucher = {
  id: null,
  code: '',
  description: '',
  type: 'fixed',
  value: 10000,
  usage_limit: 1,
  usage_limit_per_customer: 1,
  min_order_amount: 0,
  max_discount_amount: null,
  is_active: true,
  is_public: true,
  limit: {
    time: {
      is_limit: false,
      start: null,
      end: null,
    },
  },
};

const useVoucherModal = ({ open, onClose, id, onSaved }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [voucher, setVoucher] = useState({});
  const { showLoading, showNotify } = useApp();
  const [form] = Form.useForm();

  const loadData = async () => {
    if (!id) {
      setVoucher(normalizeVoucher(defaultVoucher));
      return;
    }

    const currentVoucher = await service.get(id);
    setVoucher(normalizeVoucher(currentVoucher));
  };

  useEffect(() => {
    setIsModalOpen(open);
    loadData();
  }, [open, id]);

  useEffect(() => {
    form.setFieldsValue(voucher);
  }, [voucher, form]);

  const handleOk = () => {
    if (typeof document !== 'undefined' && document.activeElement?.blur) {
      document.activeElement.blur();
    }
    form.submit();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    onClose();
  };

  const onFinish = async (values) => {
    showLoading(true);
    try {
      const savedVoucher = await service.create(values);
      setVoucher(normalizeVoucher(savedVoucher));
      showNotify(`Voucher ${savedVoucher.code} đã được lưu`);
      if (onSaved) {
        onSaved(savedVoucher);
      }
    } catch (error) {
      console.log('error', error);
    }
    onClose();
    showLoading(false);
  };

  const copyVoucherCode = async (text) => {
    await window.navigator.clipboard.writeText(text);
    showNotify(`Đã copy ${text}`);
  };

  return {
    form,
    isModalOpen,
    voucher,
    handleOk,
    handleCancel,
    onFinish,
    copyVoucherCode,
  };
};

export default useVoucherModal;